var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOutgoingOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 15C15.2011 15 19.5 16.7626 19.5 20.6429C19.5 22.6593 18.7189 23.5 17.0441 23.5H3.45588C1.78111 23.5 1 22.6593 1 20.6429C1 16.7626 5.29892 15 10.25 15ZM10.25 17C6.30402 17 3 18.3547 3 20.6429C3 21.5338 2.92853 21.5064 3.37213 21.5006L17.0441 21.5C17.5801 21.5 17.5 21.5862 17.5 20.6429C17.5 18.3547 14.196 17 10.25 17ZM22.2929 7.29289C22.6834 6.90237 23.3166 6.90237 23.7071 7.29289L27.7071 11.2929C28.0976 11.6834 28.0976 12.3166 27.7071 12.7071L23.7071 16.7071C23.3166 17.0976 22.6834 17.0976 22.2929 16.7071C21.9024 16.3166 21.9024 15.6834 22.2929 15.2929L24.585 13H18.5C17.9872 13 17.5645 12.614 17.5067 12.1166L17.5 12C17.5 11.4477 17.9477 11 18.5 11H24.585L22.2929 8.70711C21.9324 8.34662 21.9047 7.77939 22.2097 7.3871L22.2929 7.29289ZM10 3C13.0385 3 15.5 5.46147 15.5 8.5C15.5 11.5385 13.0385 14 10 14C6.96147 14 4.5 11.5385 4.5 8.5C4.5 5.46147 6.96147 3 10 3ZM10 5C8.06603 5 6.5 6.56603 6.5 8.5C6.5 10.434 8.06603 12 10 12C11.934 12 13.5 10.434 13.5 8.5C13.5 6.56603 11.934 5 10 5Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutgoingOutline);
export default __webpack_public_path__ + "static/media/user_outgoing_outline.348439eeac6f93f0a60f681e3fc3fb42.svg";
export { ForwardRef as ReactComponent };